// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"6f3893cd9fc65e520a99","6980":"266147f08c995e67a2b0"}[chunkId] + ".js";
};